/** The people opened lately, for the palette's resting list. Kept for the tab's session only: names do not outlive it. */

const KEY = "keystone:v2:recent-people";
const MAX = 3;

export interface Recent {
  id: number;
  name: string;
}

const valid = (r: unknown): r is Recent => !!r && typeof (r as Recent).id === "number" && typeof (r as Recent).name === "string";

export function readRecent(): Recent[] {
  try {
    const list: unknown = JSON.parse(sessionStorage.getItem(KEY) ?? "[]");
    return Array.isArray(list) ? list.filter(valid).slice(0, MAX) : [];
  } catch {
    return [];
  }
}

export function writeRecent(list: readonly Recent[]): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    // Storage is blocked: the list still works until the page reloads.
  }
}

/** `person` first, once. */
export const front = (list: readonly Recent[], person: Recent): Recent[] => [person, ...list.filter((r) => r.id !== person.id)].slice(0, MAX);
